export {default} from './Logo';